module.exports = __webpack_public_path__ + "assets/img/s1_tab1_active.72abbf08.png";